<script>
import DataGridPopoverPage from './DataGridPopoverPage'
import routeConfig from '../../../constants/routeConfig'
import globalEvent from '../../../constants/globalEvent'
export default {
  name: 'DataGridPopoverRelatePage',
  extends: DataGridPopoverPage,
  methods: {
    reloadGridData () {
      this.$bus.$emit(`${globalEvent.templateGrid.DATA_STATE_CHANGED}:${this.$attrs[routeConfig.DataGrid.param]}`)
      this.$emit('reloadGridData')
    },
    installDataEvent () {
      this.$bus.$on(`${globalEvent.templateGrid.DATA_CHANGED}:${this.extraKey}`, this.reloadGridData)
      this.$bus.$on(`${globalEvent.templateGrid.DATA_STATE_CHANGED}:${this.extraKey}`, this.reloadGridData)
    },
    uninstallDataEvent () {
      this.$bus.$off(`${globalEvent.templateGrid.DATA_CHANGED}:${this.extraKey}`, this.reloadGridData)
      this.$bus.$off(`${globalEvent.templateGrid.DATA_STATE_CHANGED}:${this.extraKey}`, this.reloadGridData)
    }
  },
  mounted () {
    this.installDataEvent()
  },
  beforeDestroy () {
    this.uninstallDataEvent()
  },
  watch: {
    extraKey: function (val) {
      this.uninstallDataEvent()
      if (val) {
        this.installDataEvent()
      }
    }
  }
}
</script>
